var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSecuretx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 8.00004C13.3337 7.26471 12.7357 6.66671 12.0003 6.66671H11.3337V4.66671C11.3337 2.82871 9.83833 1.33337 8.00033 1.33337C6.16233 1.33337 4.66699 2.82871 4.66699 4.66671V6.66671H4.00033C3.26499 6.66671 2.66699 7.26471 2.66699 8.00004V13.3334C2.66699 14.0687 3.26499 14.6667 4.00033 14.6667H12.0003C12.7357 14.6667 13.3337 14.0687 13.3337 13.3334V8.00004ZM6.00033 4.66671C6.00033 3.56404 6.89766 2.66671 8.00033 2.66671C9.10299 2.66671 10.0003 3.56404 10.0003 4.66671V6.66671H6.00033V4.66671Z",
    fill: "#62718A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuretx);
export default __webpack_public_path__ + "static/media/securetx.a2b53415925f50ae2009e300d9297166.svg";
export { ForwardRef as ReactComponent };